// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n3-pane {
	padding: 1rem;
	border-top: solid 1px var(--color-data-pane-border-top, black);
	border-left: solid 1px var(--color-data-pane-border-top, black);
	border-bottom: solid 1px var(--color-data-pane-border-side, #777);
	border-right: solid 1px var(--color-data-pane-border-side, #777);
	color: var(--color-text-blue, #004);
	box-sizing: border-box;
}

.n3-pane__source {
	overflow-x: auto;
	max-width: 100%;
	box-sizing: border-box;
	font-family: monospace;
	font-size: 120%;
	margin: 0;
	white-space: pre;
}

.n3-pane__line {
	white-space: pre;
}

.n3-pane[data-layout='mobile'] .n3-pane__source {
	overflow-wrap: anywhere;
	word-break: break-word;
	white-space: normal;
}

.n3-pane[data-layout='mobile'] .n3-pane__line {
	white-space: pre-wrap;
	padding-left: var(--n3-indent, 0);
	text-indent: calc(-1 * var(--n3-indent, 0));
}

@media (max-width: 576px) {
	.n3-pane__source {
		overflow-wrap: anywhere;
		word-break: break-word;
		white-space: normal;
	}

	.n3-pane__line {
		white-space: pre-wrap;
		padding-left: var(--n3-indent, 0);
		text-indent: calc(-1 * var(--n3-indent, 0));
	}
}`, "",{"version":3,"sources":["webpack://./src/n3Pane.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,8DAA8D;CAC9D,+DAA+D;CAC/D,iEAAiE;CACjE,gEAAgE;CAChE,mCAAmC;CACnC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,sBAAsB;CACtB,eAAe;CACf,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,iCAAiC;CACjC,2CAA2C;AAC5C;;AAEA;CACC;EACC,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;EACrB,iCAAiC;EACjC,2CAA2C;CAC5C;AACD","sourcesContent":[".n3-pane {\n\tpadding: 1rem;\n\tborder-top: solid 1px var(--color-data-pane-border-top, black);\n\tborder-left: solid 1px var(--color-data-pane-border-top, black);\n\tborder-bottom: solid 1px var(--color-data-pane-border-side, #777);\n\tborder-right: solid 1px var(--color-data-pane-border-side, #777);\n\tcolor: var(--color-text-blue, #004);\n\tbox-sizing: border-box;\n}\n\n.n3-pane__source {\n\toverflow-x: auto;\n\tmax-width: 100%;\n\tbox-sizing: border-box;\n\tfont-family: monospace;\n\tfont-size: 120%;\n\tmargin: 0;\n\twhite-space: pre;\n}\n\n.n3-pane__line {\n\twhite-space: pre;\n}\n\n.n3-pane[data-layout='mobile'] .n3-pane__source {\n\toverflow-wrap: anywhere;\n\tword-break: break-word;\n\twhite-space: normal;\n}\n\n.n3-pane[data-layout='mobile'] .n3-pane__line {\n\twhite-space: pre-wrap;\n\tpadding-left: var(--n3-indent, 0);\n\ttext-indent: calc(-1 * var(--n3-indent, 0));\n}\n\n@media (max-width: 576px) {\n\t.n3-pane__source {\n\t\toverflow-wrap: anywhere;\n\t\tword-break: break-word;\n\t\twhite-space: normal;\n\t}\n\n\t.n3-pane__line {\n\t\twhite-space: pre-wrap;\n\t\tpadding-left: var(--n3-indent, 0);\n\t\ttext-indent: calc(-1 * var(--n3-indent, 0));\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
